import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=bf4ed564&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4ed564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf4ed564')) {
      api.createRecord('bf4ed564', component.options)
    } else {
      api.reload('bf4ed564', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=bf4ed564&scoped=true&", function () {
      api.rerender('bf4ed564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ef95sz9CSqZp/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports